<template lang="pug">
  include ./../../../mixins
  div.rel(style='height: 100%')
    +b.el--p_v_2xs
      +b.swiper.v-swiper-nav.halls-slider-thumbs
        +b.swiper-wrapper
          +b.swiper-slide(v-for="item in cards")
            +b.SPAN.ds-caption--c_white.--size_xs.--w_r.--upp.--h_130.--op-5 {{item.title}}
    +b.el--p_t_1lg
      +b.swiper.v-swiper-center.halls-slider-top
        +b.swiper-wrapper
          +b.swiper-slide(v-for="item in cards")
            +b.img--industries
              +b.H2.ds-caption--c_white.--w_r.--h_130.--size_lg.--upp.title {{item.title}}
              +b.IMG(:src="item.img")
            +b.el--p_t_md
              +b.swiper-button-group
                +b.swiper-prev-ind.swiper-prev
                +b.line--h
                +b.swiper-next-ind.swiper-next
            +b.el--p_v_2xs.--p_t_1lg
              +b.P.ds-caption--c_white.--size_1xs.--w_l.--h_200.tac(v-html="item.text")

</template>

<script>
import Swiper from 'swiper/swiper-bundle.esm.browser';

export default {
  components: {
    Swiper,
  },
  data() {
    return {}
  },
  props: {
    cards: {},
  },
  async mounted() {
    const galleryTop = new Swiper('.halls-slider-top', {
      slidesPerView: 1,
      navigation: {
        nextEl: '.swiper-next-ind',
        prevEl: '.swiper-prev-ind',
      },
    });
    const galleryThumbs = new Swiper('.halls-slider-thumbs', {
      spaceBetween: 20,
      centeredSlides: true,
      slidesPerView: 'auto',
      slideToClickedSlide: true,
    });
    galleryTop.controller.control = galleryThumbs;
    galleryThumbs.controller.control = galleryTop;
  },
  methods: {
    checkWidthSlide() {
      const slider = document.querySelector('.halls-slider-thumbs')
      if (slider) {
        const SliderSliders = slider.querySelectorAll('.swiper-slide')
        SliderSliders.forEach(el => {
          // eslint-disable-next-line no-param-reassign
          el.style.width = `${el.querySelector('span').offsetWidth}px`
        })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// ./src/js/components/app/UiElements/UiSwiperIndustries.vue